// extracted by css-extract-rspack-plugin
export default {"wrapper":"ReferenceLink-module__wrapper___taiki","link":"ReferenceLink-module__link___X8QlY","comments":"ReferenceLink-module__comments___AbLBv"};